<script>
export default {
  props: {
    show: Boolean,
    result: {
      type: Object,
      default: () => ({ success: [], skipped: [], failed: [] }),
    },
  },

  computed: {
    modalShow: {
      get() {
        return this.show;
      },
      set(val) {
        if (!val) this.$emit("close");
      },
    },

    // gabungan baris skipped + failed, ditandai statusnya masing-masing
    combinedRows() {
      const skipped = (this.result.skipped ?? []).map((item) => ({
        ...item,
        status: "Dilewati",
      }));
      const failed = (this.result.failed ?? []).map((item) => ({
        ...item,
        status: "Gagal",
      }));
      return [...failed, ...skipped].sort(
        (a, b) => (a.row ?? 0) - (b.row ?? 0)
      );
    },

    // kolom selain "row", "message", dan "status" ditampilkan otomatis
    // mengikuti field apa pun yang dikirim BE, karena strukturnya bisa berubah.
    dynamicColumns() {
      const keys = new Set();
      this.combinedRows.forEach((item) => {
        Object.keys(item).forEach((key) => {
          if (!["row", "message", "status"].includes(key)) keys.add(key);
        });
      });
      return Array.from(keys);
    },
  },

  methods: {
    formatColumnLabel(key) {
      return key
        .replace(/_/g, " ")
        .replace(/\b\w/g, (char) => char.toUpperCase());
    },
  },
};
</script>

<template>
  <b-modal
    v-model="modalShow"
    title="Detail Data Tidak Terimport"
    size="lg"
    hide-footer
  >
    <p class="mb-2">
      <strong>{{ result.success.length }}</strong> baris berhasil,
      <strong>{{ result.skipped.length }}</strong> baris dilewati,
      <strong>{{ result.failed.length }}</strong> baris gagal diimport.
    </p>

    <div class="table-responsive">
      <table class="table table-sm table-bordered mb-0">
        <thead>
          <tr>
            <th width="60px">Row</th>
            <th width="90px">Status</th>
            <th v-for="key in dynamicColumns" :key="key">
              {{ formatColumnLabel(key) }}
            </th>
            <th>Pesan</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in combinedRows" :key="index">
            <td>{{ item.row }}</td>
            <td>
              <span
                class="badge"
                :class="item.status === 'Gagal' ? 'bg-danger' : 'bg-warning'"
              >
                {{ item.status }}
              </span>
            </td>
            <td v-for="key in dynamicColumns" :key="key">{{ item[key] }}</td>
            <td>{{ item.message }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="text-end mt-3">
      <b-button variant="secondary" @click="$emit('close')">
        Tutup
      </b-button>
    </div>
  </b-modal>
</template>
